import { render, staticRenderFns } from "./CampaignDetails.vue?vue&type=template&id=0af53c74&scoped=true"
import script from "./CampaignDetails.vue?vue&type=script&lang=ts"
export * from "./CampaignDetails.vue?vue&type=script&lang=ts"
import style0 from "./CampaignDetails.vue?vue&type=style&index=0&id=0af53c74&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af53c74",
  null
  
)

export default component.exports